import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = ({ info }) => (
  <div data-testid="unsub-company-info" className="mt-8 pt-5 border-t border-slate-200 text-xs text-slate-500 leading-relaxed">
    <p className="font-semibold text-slate-700">{info?.company_name || "King of IT"}</p>
    {info?.company_address && <p>{info.company_address}</p>}
    {info?.company_phone && <p>{info.company_phone}</p>}
  </div>
);

export default function UnsubscribePage() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [phase, setPhase] = useState(token ? "loading" : "form");
  const [email, setEmail] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!token) {
      axios.get(`${API}/unsubscribe/_`).then(({ data }) => setInfo(data)).catch(() => {});
      return;
    }
    axios.get(`${API}/unsubscribe/${token}`).then(({ data }) => {
      setInfo(data);
      setPhase(!data.valid ? "form" : data.already ? "done" : "confirm");
    }).catch(() => setPhase("form"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setPhase("working");
    try {
      const { data } = token && info?.valid
        ? await axios.post(`${API}/unsubscribe/${token}`, {})
        : await axios.post(`${API}/unsubscribe`, { email });
      setInfo((i) => ({ ...i, ...data }));
      setPhase("done");
    } catch (ex) {
      setErr(ex.response?.data?.detail || "Something went wrong. Please try again.");
      setPhase(token && info?.valid ? "confirm" : "form");
    }
  };

  const btn = "w-full rounded-lg bg-slate-900 text-white font-semibold py-3 text-base hover:bg-slate-700 transition-colors disabled:opacity-50";
  return (
    <div className="min-h-screen bg-slate-50 flex items-start sm:items-center justify-center px-4 py-10">
      <div data-testid="unsubscribe-page" className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-7 text-slate-800">
        {phase === "loading" && <p className="text-slate-500">Loading…</p>}
        {(phase === "confirm" || (phase === "working" && info?.valid)) && (
          <form onSubmit={submit}>
            <h1 data-testid="unsub-question" className="text-xl font-bold mb-6">Unsubscribe {info.masked_email} from King of IT emails?</h1>
            <button data-testid="unsub-confirm-button" disabled={phase === "working"} className={btn}>{phase === "working" ? "Unsubscribing…" : "Unsubscribe"}</button>
          </form>
        )}
        {(phase === "form" || (phase === "working" && !info?.valid)) && (
          <form onSubmit={submit}>
            <h1 className="text-xl font-bold mb-2">Unsubscribe from King of IT emails</h1>
            <p className="text-sm text-slate-600 mb-5">{token ? "This link is no longer valid. " : ""}Enter your email address and we'll stop emailing you.</p>
            <input data-testid="unsub-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" className="w-full border border-slate-300 rounded-lg px-3 py-3 text-base mb-4 focus:outline-none focus:ring-2 focus:ring-slate-900" />
            <button data-testid="unsub-email-submit" disabled={phase === "working"} className={btn}>{phase === "working" ? "Unsubscribing…" : "Unsubscribe"}</button>
          </form>
        )}
        {phase === "done" && (
          <h1 data-testid="unsub-done" className="text-xl font-bold">You've been unsubscribed. You won't hear from King of IT again.</h1>
        )}
        {err && <p data-testid="unsub-error" className="text-sm text-red-600 mt-3">{err}</p>}
        <Footer info={info} />
      </div>
    </div>
  );
}
